module.exports = __webpack_public_path__ + "static/media/logo-without-slogan.3da658b5.svg";